<template>
    <div>
        <CCol sm="12">
            <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" @click="GoToSettingProfile()"/>
            <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
        </CCol>
        <CCol sm="12">
            
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Contact Detail</h3>
                            </CCol>
                            <CCol sm="2">
                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Phone Number</h3>
                                        <CInput type="text" v-model="detailStaff.PhoneNumber" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Mobile Number</h3>
                                        <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Email</h3>
                                        <CInput type="text" v-model="detailStaff.PositionName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Personal Email</h3>
                                        <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Address</h3>
                                        <CTextarea type="textarea" v-model="detailStaff.Address" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Mailing Address</h3>
                                        <CTextarea type="textarea" v-model="detailStaff.Address" disabled/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
    
                    </div>
                </div>
    
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Emergency Contact</h3>
                            </CCol>
                            <CCol sm="2">
                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Contact Name</h3>
                                        <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Contact Phone (Mobile)</h3>
                                        <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
    
                    </div>
                </div>
                </CCard>
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},

        }





    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();

    },

    computed: {

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        async GoToSettingProfile(pageName = "SettingProfile") {
            let id = this.$route.query.id; // Retrieve the `id` from the current route

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                // Fetch the user ID using GetInfoUser method
                try {
                    await this.GetInfoUser(); // Call GetInfoUser to populate `this.user`
                    id = this.user?.id; // Assume `this.user` contains `id` after fetching

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); // Redirect to login if ID is missing
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            // Navigate to the specified page with the resolved `id` as query parameter
            this.$router.push({ name: pageName, query: { id } });
        },


    }

};
</script>